import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";
import { ACCENTS } from "@/data/site";

// Small circular cursor dot that follows the mouse with easing and grows
// over interactive elements, tinting to the nearest accent color.
export const CustomCursor = () => {
  const reduce = useReducedMotion();
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });
  const [hovering, setHovering] = useState(false);
  const [color, setColor] = useState("#0A0A0A");

  useEffect(() => {
    if (reduce) return;
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!fine) return;
    document.body.classList.add("owo-cursor-active");

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target.closest(
        "a,button,[data-cap],[data-cursor-hover],input,select,textarea"
      );
      if (el) {
        setHovering(true);
        const c = el.getAttribute("data-cursor-color");
        setColor(c || ACCENTS.red);
      } else {
        setHovering(false);
        setColor("#0A0A0A");
      }
    };
    window.addEventListener("mousemove", move);
    return () => {
      window.removeEventListener("mousemove", move);
      document.body.classList.remove("owo-cursor-active");
    };
  }, [reduce, x, y]);

  if (reduce) return null;

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[9998] hidden md:block"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        className="-translate-x-1/2 -translate-y-1/2 rounded-full"
        animate={{
          width: hovering ? 46 : 14,
          height: hovering ? 46 : 14,
          backgroundColor: hovering ? "transparent" : "#0A0A0A",
          borderColor: color,
          borderWidth: hovering ? 2 : 0,
        }}
        transition={{ type: "spring", stiffness: 400, damping: 28 }}
        style={{ borderStyle: "solid" }}
      />
    </motion.div>
  );
};
